import React, { useEffect, useRef, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import "./HomeVegetableSlider.css";

const HomeVegetableSlider = () => {
  const [products, setProducts] = useState([]);
  const [selectedWeights, setSelectedWeights] = useState({});
  const sliderRef = useRef(null);
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [sectionContent, setSectionContent] = useState({});

  useEffect(() => {
    const fetchSectionContent = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/admin/section-content/HomeVegetableSlider`);
        setSectionContent(response.data);
      } catch (err) {
        console.error("Failed to fetch section content:", err);
      }
    };
    const fetchVegetables = async () => {
      if (sectionContent.category) {
        try {
          const res = await axios.get(`${API_BASE_URL}/api/products/category/${sectionContent.category}`);
          setProducts(res.data || []);
        } catch (err) {
          console.error("Failed to fetch products:", err);
        }
      }
    };
    fetchSectionContent();
    fetchVegetables();
  }, [API_BASE_URL, sectionContent.category]);

  const handleWeightChange = (productId, weightIndex) => {
    setSelectedWeights((prev) => ({
      ...prev,
      [productId]: weightIndex,
    }));
  };

  const handleAddToCart = async (product) => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
      return;
    }

    const selectedIndex = selectedWeights[product._id] || 0;
    const weightObj = product.weights[selectedIndex];

    try {
      await axios.post(
        `${API_BASE_URL}/api/cart/add`,
        {
          productId: product._id,
          name: product.name,
          image: product.images[0],
          weight: weightObj.weight,
          price: weightObj.price,
          quantity: 1,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
    } catch (error) {
      console.error("Add to cart error:", error);
    }
  };

  const scrollSlider = (dir) => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({
        left: dir === "left" ? -300 : 300,
        behavior: "smooth",
      });
    }
  };

  if (products.length === 0 && !sectionContent.heading) {
    return null;
  }

  return (
    <div className="vegetable-slider-wrapper">
      <div className="vegetable-slider-top">
        <div className="vegetable-banner-container">
          <img
            src={sectionContent.bannerImage}
            alt="Promo"
            className="vegetable-banner"
          />
        </div>
        <div className="vegetable-text">
          <h2 className="vegetable-heading">{sectionContent.heading}</h2>
          <p className="vegetable-subheading">{sectionContent.subheading}</p>
        </div>
      </div>

      <div className="vegetable-slider-header">
        <div className="vegetable-nav-arrows">
          <button onClick={() => scrollSlider("left")} className="vegetable-arrow-btn">
            <i className="bi bi-caret-left-fill"></i>
          </button>
          <button onClick={() => scrollSlider("right")} className="vegetable-arrow-btn">
            <i className="bi bi-caret-right-fill"></i>
          </button>
        </div>
      </div>

      <div className="vegetable-slider" ref={sliderRef}>
        {products.map((p) => {
          const selectedIndex = selectedWeights[p._id] || 0;
          const selectedWeight = p.weights[selectedIndex];

          return (
            <div className="vegetable-card" key={p._id}>
              <div className="vegetable-discount-tag">Offer</div>
              <img src={p.images[0]} alt={p.name} className="vegetable-img" />
              <div className="vegetable-details">
                <h6 className="vegetable-title">{p.name}</h6>
                <select
                  className="vegetable-weight-dropdown"
                  onChange={(e) => handleWeightChange(p._id, parseInt(e.target.value))}
                  value={selectedIndex}
                >
                  {p.weights.map((w, i) => (
                    <option key={i} value={i}>
                      {w.weight}
                    </option>
                  ))}
                </select>
                <div className="vegetable-price">
                  ₹ {selectedWeight.price}
                  <span className="vegetable-mrp">₹{selectedWeight.mrp}</span>
                </div>
                <Link to={`/product/${p._id}`}>
                  <button className="vegetable-view-btn">
                    View Details <i className="bi bi-chevron-right"></i>
                  </button>
                </Link>
                <button className="vegetable-cart-btn" onClick={() => handleAddToCart(p)}>
                  <i className="bi bi-cart-plus"></i> Add
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default HomeVegetableSlider;